import React from "react"
import { useSelector } from "react-redux"

import { selectScopedByClient } from "../../stores/appSlice"
import ChannelPartnerTable from "./components/ChannelPartnerTable"
import ChannelPartnerForm from "./components/ChannelPartnerForm"
import DashboardPlaceholder from "../../components/utilityComponents/placeholders/DashboardPlaceholder"

export default function ChannelPartnerPage({ view, recordSelected }) {
    const scopedByClient = useSelector(selectScopedByClient)

    const renderView = () => {
        switch (view) {
            case "index":
                return renderIndex()
            case "form":
                return renderForm()
            default:
                return renderIndex()
        }
    }

    const renderDashboard = () => {
        if (!scopedByClient) {
            return null
        }

        return <DashboardPlaceholder />
    }

    const renderIndex = () => {
        if (scopedByClient) {
            return (
                <>
                    <ChannelPartnerTable scopedByClient={scopedByClient} />
                </>
            )
        }

        return <ChannelPartnerTable scopedByClient={scopedByClient} />
    }

    const renderForm = () => {
        if (recordSelected) {
            return (
                <>
                    <h1>Edit Form</h1>
                    <ChannelPartnerForm actionName="edit" />
                </>
            )
        }

        return (
            <>
                <h1>New Form</h1>
                <ChannelPartnerForm actionName="new" />
            </>
        )
    }

    const renderBills = () => {
        return <h1>ChannelPartner's Bills</h1>
    }

    return <>{renderView()}</>
}
